/**
 * Shows the full text as a native tooltip (title attribute) only when the
 * element is actually cut off — either by CSS line clamping / overflow, or
 * because Liquid already shortened the rendered text.
 *
 * Usage: <a data-truncate-tooltip="{{ full.text | escape }}" class="truncate-2">...</a>
 */
(function () {
  if (window.truncateTooltipLoaded) return;
  window.truncateTooltipLoaded = true;

  const SELECTOR = '[data-truncate-tooltip]';

  function isOverflowing(element) {
    return element.scrollHeight - element.clientHeight > 1 || element.scrollWidth - element.clientWidth > 1;
  }

  function update(element) {
    const fullText = element.getAttribute('data-truncate-tooltip');
    if (!fullText) return;

    const truncated = isOverflowing(element) || element.textContent.trim() !== fullText;

    if (truncated) {
      if (element.getAttribute('title') !== fullText) element.setAttribute('title', fullText);
    } else if (element.hasAttribute('title')) {
      element.removeAttribute('title');
    }
  }

  function updateAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(update);
  }

  // Re-check on hover so cards added after load (sliders, filters, quick views) are covered.
  document.addEventListener('mouseover', (event) => {
    const element = event.target.closest ? event.target.closest(SELECTOR) : null;
    if (element) update(element);
  });

  const onResize = typeof debounce === 'function' ? debounce(() => updateAll(), 150) : () => updateAll();
  window.addEventListener('resize', onResize);
  document.addEventListener('shopify:section:load', (event) => updateAll(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateAll());
  } else {
    updateAll();
  }

  // Fonts land after first paint and change where the clamp falls.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => updateAll());
  }
})();
